<div *ngIf="pageLoading1 || pageLoading2 || pageLoading3" class="loader text-center">
	<img src="../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if (navbar.userAccess?.Hospital_Master=='Full') {
<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-3">
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="">
				<label for="name">Name*</label>
			</div>
			<p *ngIf="showError('name')" class="text-danger">
				<span *ngIf="f.name.errors?.required">
					Required
				</span>
				<span *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('email')}" id="email"
					formControlName="email" placeholder="">
				<label for="email">Email</label>
			</div>
			<p *ngIf="showError('email')" class="text-danger">
				<span *ngIf="f.email.errors?.required">
					Required
				</span>
				<span *ngIf="f.email.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.email.errors?.incorrect">
					{{customError.email}}
				</span>
			</p>
		</div>
		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<ng-select [ngClass]="{'is-invalid':showError('type')}" appendTo="body" [items]="hospitalTypes"
				bindLabel="name" bindValue="id" [clearable]="true" [multiple]="false" id="type" formControlName="type"
				placeholder="Type" [appearance]="'outline'">
			</ng-select>
			<p *ngIf="showError('type')" class="text-danger">
				<span *ngIf="f.type.errors?.required">
					Required
				</span>
				<span *ngIf="f.type.errors?.incorrect">
					{{customError.type}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="row g-0">
				<div class="col">
					<ng-select [ngClass]="{'is-invalid':showError('country_code')}" appendTo="body"
						[items]="countryCodes" bindLabel="display" bindValue="dial_code" [clearable]="true"
						[multiple]="false" id="country_code" formControlName="country_code" placeholder="Country Code*"
						[appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('country_code')" class="text-danger">
						<span *ngIf="f.country_code.errors?.required">
							Required
						</span>
						<span *ngIf="f.country_code.errors?.incorrect">
							{{customError.country_code}}
						</span>
					</p>
				</div>
				<div class="col">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('phone_number')}"
							id="phone_number" formControlName="phone_number" placeholder="">
						<label for="phone_number">Phone Number*</label>
					</div>
					<p *ngIf="showError('phone_number')" class="text-danger">
						<span *ngIf="f.phone_number.errors?.required">
							Required
						</span>
						<span *ngIf="f.phone_number.errors?.pattern">
							Invalid
						</span>
						<span *ngIf="f.phone_number.errors?.incorrect">
							{{customError.phone_number}}
						</span>
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('address')}" id="address"
					formControlName="address" placeholder="">
				<label for="address">Address*</label>
			</div>
			<p *ngIf="showError('address')" class="text-danger">
				<span *ngIf="f.address.errors?.required">
					Required
				</span>
				<span *ngIf="f.address.errors?.incorrect">
					{{customError.address}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<ng-select [ngClass]="{'is-invalid':showError('country')}" appendTo="body" [items]="countryList"
				bindLabel="countryName" bindValue="countryID" [clearable]="true" [multiple]="false" id="country"
				formControlName="country" placeholder="Country*" [appearance]="'outline'"
				(change)="getStatesByCountry()">
			</ng-select>
			<p *ngIf="showError('country')" class="text-danger">
				<span *ngIf="f.country.errors?.required">
					Required
				</span>
				<span *ngIf="f.country.errors?.incorrect">
					{{customError.country}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<ng-select [ngClass]="{'is-invalid':showError('state')}" appendTo="body" [items]="stateList"
				bindLabel="stateName" bindValue="stateID" [clearable]="true" [multiple]="false" id="state"
				formControlName="state" placeholder="State*" [appearance]="'outline'" (change)="getCitiesByState()">
			</ng-select>
			<p *ngIf="showError('state')" class="text-danger">
				<span *ngIf="f.state.errors?.required">
					Required
				</span>
				<span *ngIf="f.state.errors?.incorrect">
					{{customError.state}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<ng-select [ngClass]="{'is-invalid':showError('city')}" appendTo="body" [items]="cityList"
				bindLabel="cityName" bindValue="cityID" [clearable]="true" [multiple]="false" id="city"
				formControlName="city" placeholder="City*" [appearance]="'outline'" addTagText="Create City:"
				[addTag]="addCity.bind(this)">
			</ng-select>
			<p *ngIf="showError('city')" class="text-danger">
				<span *ngIf="f.city.errors?.required">
					Required
				</span>
				<span *ngIf="f.city.errors?.incorrect">
					{{customError.city}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1" [disabled]="showLoader || !modform.dirty">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}